import { memo } from "react";

const NoData = () => <span data-testid="no_data">--</span>;

export default memo(NoData);
